<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Add Anomaly Description
          </v-card-title>
          <v-card-text>
              <v-textarea label="Description" v-model="desc">
              </v-textarea>
              <v-text-field label="Relevant variable" v-model="relevant_variable"></v-text-field>
              <severity-selector class="mr-4" clearable v-model="severity" label="Severity"></severity-selector>
              <v-textarea label="Recommended Actions" v-model="recommended_actions">
              </v-textarea>
              <v-text-field label="Equipment Regex" v-model="equipment_regex"></v-text-field>
              <v-text-field label="Topic" v-model="topic"></v-text-field>
              <v-text-field label="Time Delay" v-model.number="time_delay"></v-text-field>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'AnomalyDescription')">Save</v-btn>
              <v-btn @click="dialog=false">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

  import {putAnomalyDescription} from '../helper'
    import SeveritySelector from "./SeveritySelector";
  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
      components:{SeveritySelector},
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.anomaly_description_id = item['anomaly_description_id']
          this.relevant_variable= item['relevant_variable']
          this.desc = item['desc']
          this.severity = item['severity']
          this.recommended_actions = item['recommended_actions']
          this.equipment_regex = item['equipment_regex']
          this.topic = item['topic']
          this.time_delay = item['time_delay']
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
          anomaly_description_id: null,
          relevant_variable: null,
          desc: '',
          severity: null,
          recommended_actions: null,
          equipment_regex: null,
          topic: 'default',
          time_delay: null
      }
    },
    methods: {
      initializeVar() {
        this.topic= 'default'
        this.equipment_regex= null
        this.recommended_actions= null
        this.severity= null
        this.desc=''
        this.relevant_variable= null
        this.anomaly_description_id = null
        this.time_delay = null
      },
      async addRecord () {
          await putAnomalyDescription(
              {
                  'anomaly_description_id': this.anomaly_description_id,
                  'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                  'relevant_variable': this.relevant_variable,
                  'desc': this.desc,
                  'severity': this.severity,
                  'recommended_actions': this.recommended_actions,
                  'equipment_regex': this.equipment_regex,
                  'topic': this.topic,
                  'time_delay': this.time_delay
              }
          )
          this.$emit('doreload')
          this.dialog=false
      }
    },
    name: 'AnomalyDescriptionDialog'
  }
</script>

<style scoped>

</style>
